// UI
export const SIDEBAR = "sidebar";
export const NOTIFICATION_BAR_MOBILE = "notification-bar-mobile";
export const CHATS_BAR_MOBILE = "chats-bar-mobile";
export const SIDEBAR_MOBILE = "sidebar-mobile";

// Profile

export const PROFILE = "profile";
export const EDIT_PROFILE = "edit-profile";
export const UPDATE_PROFILE_PIC = "update-profile-picture";

// Scream
export const SCREAM = "scream";
export const ADD_SCREAM = "add-scream";
export const RAND_USER_SCREAM = "random-user-scream";
export const HOME_SCREAM = "home-scream";
export const SHOW_SCREAM = "show-scream";
export const PROFILE_SCREAM = "profile-scream";

// Chats
export const SENDER = "sender";
export const RECEIVER = "receiver";
